import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filterByParamsPipe',
	pure: false
})
export class FilterByParamsPipe implements PipeTransform {
	transform(items: any[], params: Object): any {
		if (!items || !params) {
			return items;
		}

		items = items.filter(item => 
			Object.entries(params)
				.every(([key, value]) => value === undefined || item[key] === value)
		);

		return items;
	}
}
